import type { PropsWithChildren } from "react";
import { useMemo } from "react";
import type { AccessPermission } from "../api/types";
import { useClientPermissionsContext } from "../contexts/ClientPermissionsContext";

interface Props {
  permissions: AccessPermission[];
  clientCode?: string;
  NotAuthorizedComponent?: React.ReactNode;
}

const AuthorizedBox = ({ clientCode, permissions, children, NotAuthorizedComponent }: PropsWithChildren<Props>) => {
  const { hasAnyPermission, hasAnyPermissionForClient } = useClientPermissionsContext();

  const hasPermissions = useMemo(() => {
    if (clientCode) {
      return hasAnyPermissionForClient(clientCode, permissions);
    }
    return hasAnyPermission(permissions);
  }, [clientCode, hasAnyPermission, hasAnyPermissionForClient, permissions]);

  if (!hasPermissions) return NotAuthorizedComponent;

  return <>{children}</>;
};

export default AuthorizedBox;
